let mode = 'drawOnGridAndFigure';

export default function keyEvent(e) {
  if (!e.repeat) {
  return e.which
  }
}